import {action} from 'mobx';
import {ITranslate} from '../../services/LocalizationService';
import tsDate from '@techsee/techsee-date';
import {GenericFormController, IEnabledFields} from '../common-forms/controller';
import {BasicFormModel} from '../common-forms/form-model';

export class VJFormController extends GenericFormController {
    private readonly _dateFormat: string;

    constructor(
        translate: ITranslate,
        accSettings: any,
        formModel: BasicFormModel,
        onSubmitFunction: any,
        fieldsEnabled: IEnabledFields,
        dateFormat: string
    ) {
        super(translate, accSettings, formModel, onSubmitFunction, fieldsEnabled);

        this.onTodayClick = this.onTodayClick.bind(this);
        this.onYesterdayClick = this.onYesterdayClick.bind(this);
        this.onLast7DaysClick = this.onLast7DaysClick.bind(this);
        this.changeStartDate = this.changeStartDate.bind(this);
        this.changeEndDate = this.changeEndDate.bind(this);

        this._dateFormat = dateFormat.split(' ')[0];
    }

    get dateFormat(): string {
        return this._dateFormat;
    }

    get formStartDateValue(): Date | undefined {
        const {startDate} = this.formModel.fieldNames;

        return this.formModel.fields[startDate]?.value ? new Date(this.formModel.fields[startDate].value) : undefined;
    }

    get formEndDateValue(): Date | undefined {
        const {endDate} = this.formModel.fieldNames;

        return this.formModel.fields[endDate]?.value ? new Date(this.formModel.fields[endDate].value) : undefined;
    }

    get maxDate(): Date {
        return tsDate().endOf('day').toDate();
    }

    get minDate(): Date {
        return tsDate(this.formEndDateValue)
            .subtract(VJ_INTERACTION_SUMMARY_MAX_YEAR_RANGE, 'year')
            .startOf('day')
            .toDate();
    }

    @action
    changeStartDate(newDate: Date) {
        const {startDate} = this.formModel.fieldNames;

        this.formModel.fields[startDate].setValue((newDate ?? '').toString());
    }

    @action
    changeEndDate(newDate: Date) {
        const {endDate} = this.formModel.fieldNames;

        this.formModel.fields[endDate].setValue((newDate ?? '').toString());
    }

    @action
    onTodayClick() {
        const {startDate, endDate} = this.formModel.fieldNames;

        const todatStart = tsDate().startOf('day');
        const todayEnd = tsDate().endOf('day');

        this.formModel.fields[startDate].setValue(todatStart.toString());

        this.formModel.fields[endDate].setValue(todayEnd.toString());
    }

    @action
    onYesterdayClick() {
        const {startDate, endDate} = this.formModel.fieldNames;

        const yesterdayStart = tsDate().subtract(1, 'days').startOf('day');
        const yesterdayEnd = tsDate().subtract(1, 'days').endOf('day');

        this.formModel.fields[startDate].setValue(yesterdayStart.toString());

        this.formModel.fields[endDate].setValue(yesterdayEnd.toString());
    }

    @action
    onLast7DaysClick() {
        const {startDate, endDate} = this.formModel.fieldNames;

        const lastWeekStart = tsDate().subtract(6, 'days').startOf('day');
        const todayEnd = tsDate().endOf('day');

        this.formModel.fields[startDate].setValue(lastWeekStart.toString());

        this.formModel.fields[endDate].setValue(todayEnd.toString());
    }

    @action
    clearForm() {
        const {customerRef, startDate, endDate, preDataCollectionCodeRef} = this.formModel.fieldNames;

        // Clear all form fields
        if (this.formModel.fields[customerRef]) {
            this.formModel.fields[customerRef].setValue('');
        }
        if (this.formModel.fields[startDate]) {
            this.formModel.fields[startDate].setValue('');
        }
        if (this.formModel.fields[endDate]) {
            this.formModel.fields[endDate].setValue('');
        }
        if (this.formModel.fields[preDataCollectionCodeRef]) {
            this.formModel.fields[preDataCollectionCodeRef].setValue('');
        }
    }
}
